import HTMLReactParser from "html-react-parser";
import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { GeneralQuality } from "../../../lib/types";
import { investSkillPoint } from "../../../store/actions";

interface IProps {
  generalId: number;
  skill: GeneralQuality;
  available: boolean;
  exclusive?: number;
}

const mapDispatchToProps = (dispatch: any) => ({
  investSkillPointDispatch:
    (generalId: number, skillId: number) => dispatch(investSkillPoint(generalId, skillId))
})

const connector = connect(null, mapDispatchToProps);

const GeneralSkillInfo = ({
  generalId,
  skill,
  available,
  exclusive,
  investSkillPointDispatch,
}: IProps & ConnectedProps<typeof connector>) => (
  skill ? <>
    <h3 className="title">{skill.name}</h3>
    <p className="text-center">
      <strong>Level: {skill.level}/{skill.tier === 4 ? "2" : "4"}</strong><br/>
      {skill.level > 0 ? HTMLReactParser(skill.description || "") : "-"}
      <br />
      {skill.level < (skill.tier === 4 ? 2 : 4)
        ? <><strong>Next Level:</strong><br />{HTMLReactParser(skill.nextDescription || skill.enrichedDescription || "")}</>
        : <span>Max Level</span>}
      {exclusive && <><br/><small>Exclusive with: <b>{exclusive}</b></small></>}
    </p>
    {skill.maxLevelReached
      ? <></>
      : <p>
        <a href="#"
           className={
             `btn btn-black btn-no-width ${available ? "" : "disabled"}`
           }
           onClick={() => (available
             ? investSkillPointDispatch(generalId, skill.id) : null)}
        >
          {skill.tier === 4 ? "Unlock ultimate" : "Invest 1 point"}
        </a>
      </p>
    }
  </> : <></>
)

export default connector(GeneralSkillInfo);
